import { h, Component } from 'preact';
import {connect} from 'react-redux'

@connect((state)=> state)
class Page extends Component{	
	render(){
		const Component = this.props.component
		return (
			this.props.page == this.props.componentPage ? (
				<Component settings={{...this.props.settings}}/>
			) : (
				''
			)
		)
	}
}

export default Page



// WEBPACK FOOTER //
// ./components/elements/Page/index.js